import { z } from 'zod'
import { FileStatus, type FileEntry } from '../types/file-entry'

export const BaseFileSchema = z.instanceof(File)

type FileEntryWithoutConvertingStatus = Omit<FileEntry, 'status'> & {
  status: Exclude<FileStatus, 'converting'>
}

// zod v4's ZodType is `ZodType<Output, Input = unknown>` (v3 defaulted Input to
// Output). Pin Input = Output so `z.input`/`z.output` of this schema stay equal,
// matching v3 and keeping form field-value types (which now use `z.input`) intact.
export const makeFileWithPreviewSchema = (
  // Accept any schema that yields a `File` (e.g. `z.instanceof(File)` or v4's
  // `z.file()`), not just the `ZodCustom` default inferred from `BaseFileSchema`.
  fileSchema: z.ZodType<File> = BaseFileSchema
): z.ZodType<FileEntry, FileEntry> =>
  z.object({
    getFile: z.function({
      output: fileSchema.or(z.null()),
    }),
    revokeFile: z.function({
      output: z.void(),
    }),
    id: z.string(),
    name: z.string(),
    size: z.number(),
    type: z.string(),
    isImage: z.boolean(),
    isVideo: z.boolean(),
    getThumbnail: z.function({
      output: z.promise(z.string().nullable()),
    }),
    status: z.enum(['pending', 'uploading', 'uploaded', 'error']),
    updateFile: z.function({
      input: z.any(),
      output: z.void(),
    }),
  }) as z.ZodType<FileEntryWithoutConvertingStatus, FileEntryWithoutConvertingStatus>
